import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Store, Reducer } from 'redux';
// types
import { IBootstrapAPI } from '@sitegen/common/types';
// configs
import { createApplicationStore } from './store-config/store.config';

export default class BootstrapAPI implements IBootstrapAPI {
    public store: Store | null;
    public mount: (node: HTMLElement, callback?: () => void) => void;
    private mounted: boolean = false;

    private targetNode: HTMLElement | null;

    constructor(widgetConfig: IWidgetConfig) {
        this.mount = this.prepareMount(widgetConfig);
    }

    public unmount = (): boolean => {
        this.store = null;
        this.mounted = false;

        const unmountResult = ReactDOM.unmountComponentAtNode(this.targetNode!);

        if (unmountResult) {
            this.targetNode = null;
        }

        return unmountResult;
    };

    private prepareMount = ({ widgetsComponents, widgetsRootEpics, widgetsReducers }: IWidgetConfig) => {
        // TODO:  looks like after transpiling&minification Edge v<17 loses context in resulting code making 'this'='undefined'
        // TODO: not reproducible for Edge 18, so should be deprecated in future
        const self = this;
        return (node: HTMLElement, callback?: () => void ): void => {
            if (self.mounted) {
                throw new Error('Website is already mounted!');
            }

            self.mounted = true;
            self.targetNode = node;
            self.store = createApplicationStore(widgetsReducers, widgetsRootEpics);
            ReactDOM.render(
                <Provider store={self.store}>
                    <>{widgetsComponents}</>
                </Provider>,
                self.targetNode,
                callback
            );
        };
    };
}

interface IWidgetConfig {
    readonly widgetsComponents: JSX.Element[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    readonly widgetsRootEpics: any[];
    readonly widgetsReducers: Reducer[];
}
